import { getCurrentPath } from "@faire/web--source/common/Path";
import { Accordion, AccordionItem } from "@faire/web--source/slate/Accordion";
import { Button } from "@faire/web--source/slate/Button";
import { Column } from "@faire/web--source/slate/Layout/Column";
import { getSpacing, Spacer } from "@faire/web--source/slate/spacing";
import { Typography } from "@faire/web--source/slate/Typography";

import { useTopRetailers } from "@faire/retailer/views/product/ProductDetails/__internal__/TopRetailers/useTopRetailers";

interface IProps {
  productToken: string | undefined;
}

export const TopRetailers: React.FC<IProps> = ({ productToken }) => {
  const { online_retailers, brick_and_mortar_retailers } = useTopRetailers({
    productToken,
  });

  if (!online_retailers.length && !brick_and_mortar_retailers.length) {
    return null;
  }

  const items: AccordionItem[] = brick_and_mortar_retailers
    .filter(
      (retailer) => retailer.address && retailer.address.full_formatted_address
    )
    .map((retailer) => ({
      question: (
        <Typography variant="paragraphSansRegular">
          <b>{retailer.name}</b>
          {retailer.address?.city && retailer.address?.state
            ? ` in ${retailer.address?.city}, ${retailer.address?.state}`
            : ""}
        </Typography>
      ),
      answer: (
        <iframe
          src={`https://maps.google.com/maps?output=embed&q=${encodeURIComponent(
            retailer.address?.full_formatted_address ?? ""
          )}`}
          width="100%"
          height="300px"
          style={{ border: 0 }}
          allowFullScreen
          loading="lazy"
          referrerPolicy="no-referrer-when-downgrade"
        ></iframe>
      ),
    }));

  return (
    <>
      {online_retailers.length > 0 ? (
        <>
          <Typography variant="pageHeaderSerifRegular">
            Shop Trusted Retailers
          </Typography>
          <Spacer height="1x" />
          <Column gap="1x">
            {online_retailers.slice(0, 3).map((retailer, i) => {
              return (
                <Button
                  key={i}
                  variant="primary"
                  linkTo={getCurrentPath()
                    .append({
                      consumerModeRedirect: retailer.website_url,
                    })
                    .toString()}
                >
                  {retailer.name}
                </Button>
              );
            })}
          </Column>
          <Spacer height="3x" />
        </>
      ) : null}
      {items.length > 0 ? (
        <>
          <Typography
            variant="pageHeaderSerifRegular"
            style={{ marginBottom: getSpacing("-2x") }}
          >
            Rather shop in person?
          </Typography>
          <Spacer height="1x" />
          <Accordion items={items} initiallyOpenIndex={0} title="" />
        </>
      ) : null}
    </>
  );
};
